export default __webpack_public_path__ + "static/media/ThinkTravel.13db2becf7e73db5da4363b97b352f2e.webp";